module.exports = __webpack_public_path__ + "static/media/success.ab481c51.svg";